<template>
  <container>
    <div class="subpage__cnt col-xl-10 offset-xl-1 text-center">

    </div>
    <div class="subpage-list uni-search-wrp">
      <div class="subpage-list-top">
        <img src="@/assets/img/building.png" alt="" class="city-dorms__icon">

        <div class="section__title-top">
          <div class="section__title">
            <span class="color-light-green">Choose Your</span> Network!
          </div>
          <p class="section__title-txt">You can find movies from your favorite network, you can reach movies according to your flavour ! </p>
        </div>
      </div>
            <div class="desktop-drop">
                <div class="section__right">
                  <div class="section__select" v-if="universityDetails"> -->
                    <VueSelectTempFacultyNoFilter placeholder="Select Country" :options="countries"
                                   @onselect="selectCountry"/>
                    <!-- <v-select :options="countries" placeholder="Select Country" @onselect="selectFaculty"/> -->
                   </div>
                </div>
              </div> 
      <Hero :cities="countries" :studios="studios1" :filter-dorm="false"/>
      <div class="result-bracket">
        <div class="result-bracket__title">
          <span class="result-bracket__count" v-if="list">{{ list1.length }}</span> <span v-if="list1">Networks Found!</span>
           <span v-if="!list">Networks Loading!</span> 
        </div>

                    <VueSelectTempFacultyNoFilter placeholder="Filter By Country" :options="countries"
                                   @onselect="selectCountry"/>
                    <!-- <v-select :options="countries" placeholder="Select Country" @onselect="selectFaculty"/> -->
 
      </div>

      <div class="flex-row" v-if="list1">
        <div class="subpage-list__item"
             v-for="studio in list1"
             :key="studio.id">
          <uni-card :uni="studio" />
        </div>
  <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
      </div>
      <!--<div class="featured-dorms__bottom text-center">-->
        <!--<v-link-->
          <!--to="/yurtlar"-->
          <!--class="button&#45;&#45;stroke round icon-transform"-->
          <!--title="See All"-->
          <!--icon="icon-arrow-long-right"-->
          <!--icon-position="right"-->
        <!--/>-->
      <!--</div>-->
    </div>
          <ContentLoader v-if="!list && !mobileCheck"
          :height="700">
        <rect x="20" y="0" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="0" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="0" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="0" rx="3" ry="3" width="88" height="40" />

        <rect x="20" y="45" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="45" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="45" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="45" rx="3" ry="3" width="88" height="40" />

        <rect x="20" y="90" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="90" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="90" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="90" rx="3" ry="3" width="88" height="40" />

        <rect x="20" y="135" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="135" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="135" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="135" rx="3" ry="3" width="88" height="40" />        
      </ContentLoader>1

      <ContentLoader v-if="!list && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />      
      </ContentLoader>

  <infinite-loading @infinite="infiniteHandler" spinner="waveDots" >
  <div slot="no-more"></div>
  <div slot="no-results"></div>
  </infinite-loading>

  </container>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import FacultyCard from '@/components/UniSearchCard'
import Hero from '@/components/Home/NetworkSearch.vue'
import UniCard from '@/components/UniCard'
import { ContentLoader } from 'vue-content-loader'
import VueSelectTempFacultyNoFilter from '@/components/VueSelectTempFacultyNoFilter'
import axios from 'axios'
export default {
  name: 'NetworkSearch',
  components: {
    FacultyCard, Hero, UniCard, ContentLoader, VueSelectTempFacultyNoFilter, InfiniteLoading
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Studios',
       meta: [
         { vmid: 'description', name: 'description', content: 'You can find movies you search for, you can get news for the series you want, you can reach the movies in your favroite sires quickly!' },
         { vmid: 'keywords', name: 'keywords', content: 'hollywood movies, hollywod films, american movies, american cinema, holywoodskyline, movie search' }
       ],
       link: [
         { rel: 'canonical', href: window.location.origin + '/networks/' }
       ]      
    }
  },  
  data () {
    return {
      counter: 5,
      countries: [
        {name: 'All Countries', code: 'DE'},
        {name: 'Austria', code: 'AT'},
        {name: 'Australia', code: 'AU'},
{name: 'Brasil', code: 'BR'},
{name: 'Belgium', code: 'BE'},
{name: 'Canada', code: 'CA'},
{name: 'Crotia', code: 'HR'},
{name: 'Chez Republic', code: 'CZ'},
{name: 'Denmark', code: 'DK'},
{name: 'England', code: 'GB'},
{name: 'Finland', code: 'FI'},
{name: 'France', code: 'FR'},
{name: 'Germany', code: 'DE'},
{name: 'Italy', code: 'IT'},
{name: 'India', code: 'IN'},
{name: 'Ireland', code: 'IE'},
{name: 'Israel', code: 'IS,'},
{name: 'Japan', code: 'JP'},
{name: 'Luxemburg', code: 'LU'},
{name: 'Mexico', code: 'MX'},
{name: 'Netherlands', code: 'NL'},
{name: 'New Zealand', code: 'NZ'},
{name: 'Norwey', code: 'NO'},
{name: 'Portugal', code: 'PT'},
{name: 'Russia', code: 'RU'},
{name: 'South Korea', code: 'KR'},
{name: 'Spain', code: 'ES'},
{name: 'South Africa', code: 'ZA'},
{name: 'Sweden', code: 'SE'},
{name: 'Switzerland', code: 'CH'},
{name: 'United States', code: 'US'},
{name: 'Turkey', code: 'TR'},
      ],
      list: [],      
      list1: [

          {
  description: 'Netflix is is one of the worlds leading entertainment company and home to the many series',
  headquarters: 'San Francisco, California, USA',
  homepage: 'http://www.netflix.com',
  id: 35,
  logo_path: '/tyHnxjQJLH6h4iDQKhN5iqebWmX.png',
  name: 'Netflix',
  origin_country: 'US',
  parent_company: null
},      
          {
  description: 'Amazon Studios is one of the worlds leading entertainment company and home to the many series',
  headquarters: 'San Francisco, California, USA',
  homepage: 'http://www.netflix.com',
  id: 2,
  logo_path: '/oRR9EXVoKP9szDkVKlze5HVJS7g.png',
  name: 'Amazon Studios',
  origin_country: 'US',
  parent_company: null
},  
          {
  description: 'Netflix Animation is one of the worlds leading entertainment companies and home to the legendary Star Wars and Indiana Jones franchises.',
  headquarters: 'San Francisco, California, USA',
  homepage: 'http://www.netflix.com',
  id: 3,
  logo_path: '/AqUAfMC270bGGK09Nh3mycwT1hY.png',
  name: 'Netflix Animation',
  origin_country: 'US',
  parent_company: null
}, 
        {
  description: 'Lucasfilm is one of the worlds leading entertainment companies and home to the legendary Star Wars and Indiana Jones franchises.',
  headquarters: 'San Francisco, California, USA',
  homepage: 'http://www.lucasfilm.com',
  id: 4,
  logo_path: '/o86DbpburjxrqAzEDhXZcyE8pDb.png',
  name: 'Lucasfilm',
  origin_country: 'US',
  parent_company: null
}

      ],

studios1: [
{
  description: "EndemolShine is a German  film production company which is also successfull in creating box office movies",
  headquarters: "Universal City, California, USA",
  homepage: "http://dendemolshine.com",
  id: 7,
  logo_path: "/sE8X6le64dpSBtY6PX2AlN2nVkr.png",
  name: "EndemolShine Germany",
  origin_country: "DE",
  parent_company: null
},
{
  description: "ITV Studios Germany is a broadcaster-independent television production company based in Cologne and Berlin. It is a 100% subsidiary of the British media group ITV plc.",
  headquarters: "Universal City, California, USA",
  homepage: "https://www.itvstudios.de/",
  id: 7,
  logo_path: "/eu6ClWvVZyfpCWcgljZtiEP2R7v.png",
  name: "itv Studios Germany",
  origin_country: "DE",
  parent_company: null
},
{
  description: "BEECH is one of the largest film production and photo studios in Bavaria. They well-known TV commercials as well as product photos in our own new photo studio with a cove in Munich/Rosenheim.",
  headquarters: "Munich/Rosenheim, DE",
  homepage: "https://beechstudios.de/",
  id: 14,
  logo_path: "/ztX5cC4sWyP3ni38JqCfvvTlWIe.png",
  name: "Beech Studios",
  origin_country: "DE",
  parent_company: null
},
{
  description: "German Wrestling Federation is a German film production company which is also successfull in creating box office  movies",
  headquarters: "Universal City, California, USA",
  homepage: "http://germanwrestling.com",
  id: 7,
  logo_path: "/qpOiTDvvvwgnopj3B6BUMrkt1C5.png",
  name: "GWF",
  origin_country: "DE",
  parent_company: null
},
{
  description: "Granada  is a German film production company which is also successfull in creating box office  movies",
  headquarters: "Universal City, California, USA",
  homepage: "http://granadapictures.com",
  id: 7,
  logo_path: "/c0uOo1LiPWQSh7URLMDCC0rjEuz.png",
  name: "Granada",
  origin_country: "DE",
  parent_company: null
},  
  {
  description: 'Lucasfilm is one of the worlds leading entertainment companies and home to the legendary Star Wars and Indiana Jones franchises.',
  headquarters: 'San Francisco, California, USA',
  homepage: 'http://www.lucasfilm.com',
  id: 1,
  logo_path: '/o86DbpburjxrqAzEDhXZcyE8pDb.png',
  name: 'Lucasfilm',
  origin_country: 'US',
  parent_company: null
},
{
  description: "Pixar Animation Studios is an American computer animation studio based in Emeryville, California, a subsidiary of The Walt Disney Studios. ",
  headquarters: "Emeryville, California, USA",
  homepage: "http://www.pixar.com",
  id: 3,
  logo_path: "/1TjvGVDMYsj6JBxOAkUHpPEwLf7.png",
  name: "Pixar",
  origin_country: "US",
  parent_company: {
    name: "Walt Disney Pictures",
    id: 2,
    logo_path: "/wdrCwmRnLFJhEoH8GSfymY85KHT.png"
  }
},
{
  description: "Paramount Pictures is the one of oldest film studios in the world. Currently is an American film studio and subsidiary of ViacomCBS.",
  headquarters: "Hollywood, California, USA",
  homepage: "http://www.paramount.com/",
  id: 4,
  logo_path: "/fycMZt242LVjagMByZOLUGbCvv3.png",
  name: "Paramount",
  origin_country: "US",
  parent_company: {
    name: "Viacom International",
    id: 5308,
    logo_path: null
  }
},
{
  description: "Columbia Pictures Industries, Inc. (CPII) is an American film production and distribution company. Columbia Pictures now forms part of the Columbia TriStar Motion Picture Group, owned by Sony Pictures Entertainment, a subsidiary of the Japanese conglomerate Sony. It is one of the leading film companies in the world, a member of the so-called Big Six. It was one of the so-called Little Three among the eight major film studios of Hollywood's Golden Age.",
  headquarters: "Culver City, California, USA",
  homepage: "http://www.sonypictures.com",
  id: 5,
  logo_path: "/71BqEFAF4V3qjjMPCpLuyJFB9A.png",
  name: "Columbia Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "Universal Pictures is an American film studio that is one of Hollywood's biggest film companies. It is the world's fourth oldest major film studio, best known for Jaws, E.T., and Jurassic Park series.",
  headquarters: "Universal City, California, USA",
  homepage: "http://www.universalpictures.com/",
  id: 33,
  logo_path: "/mGbYwpo7isFx7RyRm26qvuSFTbw.png",
  name: "Universal Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "Sony Pictures is an American entertainment company that produces, acquires, and distributes filmed entertainment  through multiple platforms.",
  headquarters: "Culver City, California, USA",
  homepage: "http://www.sonypictures.com/",
  id: 34,
  logo_path: "/GagSvqWlyPdkFHMfQ3pNq6ix9P.png",
  name: "Sony Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "Lionsgate Films is an American film production and film distribution studio best known for Hunger Games and Jigswa franchises.",
  headquarters: "Vancouver, Canada",
  homepage: "",
  id: 35,
  logo_path: "/wxrHa3nZ1K4zo65p56991INkGo6.png",
  name: "Lions Gate Films",
  origin_country: "US",
  parent_company: null
},
{
  description: "Dreamworks Picture is an American film production company which is also successfull in creating box office anitmation movies",
  headquarters: "Universal City, California, USA",
  homepage: "http://dreamworkspictures.com",
  id: 7,
  logo_path: "/jCwNupLautLSk6iB28VXrDPUqD8.png",
  name: "DreamWorks Pictures",
  origin_country: "US",
  parent_company: null
},  
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 15,
  logo_path: null,
  name: "Lama Films",
  origin_country: null,
  parent_company: null
},
{
  description: "",
  headquarters: "Israel",
  homepage: "http://www.unitedking.co.il",
  id: 16,
  logo_path: "/gf4S6UfByfEaSpDPLl663ivyDRC.png",
  name: "United King Films",
  origin_country: "IL",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "http://www.graciefilms.com/",
  id: 18,
  logo_path: "/uqhagSwM7NAkQWVCQhKTyoqF8XH.png",
  name: "Gracie Films",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Wellington, New Zealand",
  homepage: "",
  id: 11,
  logo_path: "/6FAuASQHybRkZUk08p9PzSs9ezM.png",
  name: "WingNut Films",
  origin_country: "NZ",
},

{
  id: 19,
  name: "Film Roman",
  origin_country: "X",
},
{
  id: 20,
  name: "Rough Draft Studios",
  origin_country: "X",
},
{
  id: 22,
  name: "Alejandro González Iñárritu",
  origin_country: null,
},


{
  id: 24,
  name: "Mikona Productions GmbH & Co. KG",
  origin_country: "X",
},


{
  id: 26,
  name: "Agustin Almodovar",
  origin_country: null,
},
{
  id: 28,
  name: "Newmarket Films",
  origin_country: "US"
},
{
  id: 30,
  name: "Eddie Murphy Productions",
  origin_country: null,
},
{
  id: 31,
  name: "Hamburger Filmschule",
  origin_country: null,
},
{
  id: 32,
  name: "Buena Vista Pictures",
  origin_country: "X",
},

{
  id: 37,
  name: "Gramercy Pictures",
  origin_country: "US",
},
{
  id: 38,
  name: "Zespół Filmowy TOR",
  origin_country: null,
},
{
  id: 39,
  name: "Docurama",
  origin_country: null,
},
{
  id: 40,
  name: "Akira Committee Production",
  origin_country: null,
},
{
  id: 41,
  name: "Orion Pictures",
  origin_country: "US",
},
  {
  id: 42,
  name: "Universal Pictures Corporation",
  origin_country: null,
},
{
  id: 43,
  name: "Fox Searchlight Pictures",
  origin_country: "US",
},
{
  id: 44,
  name: "Cruise/Wagner Productions",
  origin_country: null,
},
{
  id: 45,
  name: "Road Movies Filmproduktion GmbH",
  origin_country: null,
},
{
  id: 46,
  logo_path: "/3xFdKHLXPGHEbrAkmsepGE8974Y.png",
  name: "Westdeutscher Rundfunk",
  origin_country: "DE",
  parent_company: null
},
{
  id: 47,
  logo_path: "/i7Z9ot2o3N5Sa3HrF09kniFs2y8.png",
  name: "Constantin Film",
  origin_country: "DE",
  parent_company: null
},
{
  id: 48,
  name: "Cristaldifilm S.r.l.",
  origin_country: null,
},
{
  id: 49,
  name: "El Deseo",
  origin_country: "ES",
},
{
  id: 50,
  name: "Deutsche Vereinsfilm AG",
  origin_country: null,
},
{
  id: 51,
  name: "Fox Europa Produktion",
  origin_country: null,
},
{
  id: 52,
  name: "Film Polski Film Agency",
  origin_country: null,
},
{
  id: 53,
  name: "Les Films du Carrosse",
  origin_country: "FR",
},
{
  id: 54,
  name: "The Independent Film Channel Productions",
  origin_country: null,
},
{
  id: 55,
  name: "Decla Film Gesellschaft Holz & Co.",
  origin_country: null,
},
{
  description: "",
  headquarters: "Universal City, California",
  homepage: "https://amblin.com",
  id: 56,
  logo_path: "/mpGWkDeikYLeAR8LVNaixig0vwE.png",
  name: "Amblin Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 57,
  logo_path: null,
  name: "Xenix Film",
  origin_country: null,
},
{
  id: 57,
  name: "Xenix Film",
  origin_country: null,
},
{
  id: 59,
  logo_path: "/yH7OMeSxhfP0AVM6iT0rsF3F4ZC.png",
  name: "A Band Apart",
  origin_country: "US",
  parent_company: null
},
{
  id: 60,
  logo_path: "/2eqFolQI0NLL7ExZts5MnLLaPwX.png",
  name: "United Artists",
  origin_country: "US",
},
{
  id: 62,
  name: "The Selznik Studio",
  origin_country: "US",
},
{
  id: 64,
  name: "Les Productions Artistes Associés",
  origin_country: null,
},
{
  id: 65,
  name: "Ulysse Production",
  origin_country: null,
},
{
  id: 66,
  name: "Town",
  origin_country: null,
},
{
  id: 67,
  name: "Unitec Films",
  origin_country: null,
},
{
  id: 68,
  name: "Big Primate Pictures",
  origin_country: "GB",
},
{
  id: 69,
  name: "MFPV Film",
  origin_country: null,
},
{
  description: "",
  headquarters: "San Francisco, California, USA",
  homepage: "https://www.zoetrope.com",
  id: 70,
  logo_path: "/ueaENQkPcy8rlr5fGZVBXKOhlBh.png",
  name: "American Zoetrope",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Spain",
  homepage: "http://www.elementalfilms.es",
  id: 71,
  logo_path: "/sBII9gMsUvSbGRQa1ehCTp0HVrA.png",
  name: "Elemental Films",
  origin_country: "ES",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "http://vreg.com/village-roadshow-pictures/",
  id: 79,
  logo_path: "/tpFpsqbleCzEE2p5EgvUq6ozfCA.png",
  name: "Village Roadshow Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Beverly Hills, California, USA",
  homepage: "",
  id: 81,
  logo_path: "/8wOfUhA7vwU2gbPjQy7Vv3EiF0o.png",
  name: "Plan B Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "http://www.france2cinema.fr",
  id: 83,
  logo_path: "/9OQ0rm55xtlgX7KcAKMUePJSrQc.png",
  name: "France 2 Cinéma",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "http://www.france2cinema.fr",
  id: 83,
  logo_path: "/9OQ0rm55xtlgX7KcAKMUePJSrQc.png",
  name: "France 2 Cinéma",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Issy-les-Moulineaux, France",
  homepage: "https://www.arte.tv/en",
  id: 94,
  logo_path: "/huC7HqorvUThGIrENrbcHmQVUA0.png",
  name: "ARTE France Cinéma",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Berlin, Germany",
  homepage: "http://www.x-filme.de",
  id: 96,
  logo_path: "/9ps82gVzUeNdkjmLzoGDQLiLDio.png",
  name: "X Filme Creative Pool",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "New York City, New York, USA",
  homepage: "",
  id: 97,
  logo_path: "/7znWcbDd4PcJzJUlJxYqAlPPykp.png",
  name: "Castle Rock Entertainment",
  origin_country: "US",
  parent_company: {
    name: "Warner Bros. Entertainment",
    id: 17,
    logo_path: "/s1y7CTv6YHe87YUGOq6SRB6DmO7.png"
  }
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "https://www.canalplus.fr",
  id: 104,
  logo_path: "/9aotxauvc9685tq9pTcRJszuT06.png",
  name: "Canal+",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "",
  id: 105,
  logo_path: "/pyiNvPJYGz4W2SImgULoG2sn4y4.png",
  name: "CiBy 2000",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Köln, Germany",
  homepage: "https://www.khm.de/home/",
  id: 117,
  logo_path: "/twj6GjwWKt23x21fkxItt7v7lEQ.png",
  name: "Kunsthochschule für Medien Köln",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "Denmark",
  homepage: "https://www.dfi.dk/en",
  id: 118,
  logo_path: "/AiBorgNTCS1lT1FdFPYheax9jfF.png",
  name: "Det Danske Filminstitut",
  origin_country: "DK",
  parent_company: null
},
{
  description: "",
  headquarters: "Denmark",
  homepage: "",
  id: 119,
  logo_path: "/1di2gITGUZr730AMuMKiCrP90Vl.png",
  name: "Danmarks Radio (DR)",
  origin_country: "DK",
  parent_company: null
},
{
  description: "",
  headquarters: "Germany",
  homepage: "https://www.swr.de/",
  id: 124,
  logo_path: "/7MjDMOybX0D3fcIEpCyY9es5XZU.png",
  name: "Südwestrundfunk",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "Beverly Hills, California, USA",
  homepage: "http://lakeshoreentertainment.com",
  id: 126,
  logo_path: "/kADPanRDkKTxncPXXVahvHPUvCj.png",
  name: "Lakeshore Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 130,
  logo_path: "/c9dVHPOL3cqCr2593Ahk0nEKTEM.png",
  name: "Jerry Bruckheimer Films",
  origin_country: "US",
  parent_company: null
},
{
  id: 136,
  logo_path: "/fkWq46O9I1OY3ts1yVrbHuzRANB.png",
  name: "City Light Films",
  origin_country: "US",
  parent_company: null
},
{
  id: 140,
  logo_path: "/ooz5b0ov3PLfBoOJyMmdoffVuHs.png",
  name: "Pandora Film",
  origin_country: "DE",
  parent_company: null
},
{
  id: 155,
  logo_path: "/cDY49SOQwJixJSMun9Haerx8dAQ.png",
  name: "Nimbus Film",
  origin_country: "DK",
  parent_company: null
},
{
  id: 158,
  logo_path: "/jSj8E9Q5D0Y59IVfYFeBnfYl1uB.png",
  name: "Spyglass Entertainment",
  origin_country: "US",
  parent_company: null
},
    {
      id: 159,
      logo_path: "/rYsaKUrfDoOa2UG846axs4r81Dx.png",
      name: "Shady Acres Entertainment",
      origin_country: "US"
    },

{
  id: 162,
  name: "Bayerischer Rundfunk",
  origin_country: "DE",
},{
  id: 164,
  name: "Rhombus Media",
  origin_country: "CA",
},
{
  id: 168,
  name: "Jadran Film",
  origin_country: "HR",
},
{
  id: 174,
  name: "Warner Bros. Pictures",
  origin_country: "US",
},
{
  id: 175,
  name: "Caravan Pictures",
  origin_country: "US",
},
{
  id: 177,
  logo_path: null,
  name: "Columbia TriStar",
  origin_country: "US",
},
{
  id: 181,
  name: "Channel Four Films",
  origin_country: "GB",
},
{
  id: 186,
  name: "Pyramide Productions",
  origin_country: "FR",
},
{
  id: 188,
  name: "Big Beach",
  origin_country: "US",
  parent_company: null
},
{
  id: 189,
  name: "ARP Sélection",
  origin_country: "FR",

},
{
  description: "",
  headquarters: "Berlin, Germany",
  homepage: "https://www.senator.de/",
  id: 191,
  logo_path: "/d5tPJd8jGLtJC5cp9NG0HeoTyoe.png",
  name: "Senator Film",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "Tokyo, Japan",
  homepage: "http://www.shochiku.co.jp",
  id: 192,
  logo_path: "/93eAKlnQecDdMtucfOprzcjMw9V.png",
  name: "Shochiku Co., Ltd.",
  origin_country: "JP",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "https://www.arte.tv/fr/",
  id: 201,
  logo_path: "/6UIpEURdjnmcJPwgTDRzVRuwADr.png",
  name: "ARTE",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "http://www.agatfilmsetcie.com",
  id: 207,
  logo_path: "/uskenzq65wJe0cT0D8StQI3hJnO.png",
  name: "Agat Films & Cie",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "http://www.bacfilms.com/production/",
  id: 208,
  logo_path: "/bxQYlRhQu6nbohBEL0SWz8xIAGy.png",
  name: "Bac Films",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Germany",
  homepage: "https://www.swr.de/",
  id: 210,
  logo_path: "/evEPz76DrzGqsKesjYjrWVGvRpp.png",
  name: "Südwestdeutscher Rundfunk",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "London, England",
  homepage: "https://www.eagle-vision.tv",
  id: 214,
  logo_path: "/qIptM4dZBNflgv2OXzYECv8iQNH.png",
  name: "Eagle Vision",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 215,
  logo_path: "/tQyeqkCj24krhY2W8qeAztcOS37.png",
  name: "Double Feature Films",
  origin_country: null,
  parent_company: null
},
{
  description: "",
  headquarters: "Paris ",
  homepage: "http://www.filmsdulosange.fr/en/",
  id: 223,
  logo_path: "/b9Icqi8qGm7gJ6jVs8bauUo5N5Q.png",
  name: "Les Films du Losange",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "http://www.bimfilm.com/",
  id: 225,
  logo_path: "/cmxkBc3dmwWaIHFCrkXZoAfGoOa.png",
  name: "BIM Distribuzione",
  origin_country: "IT",
  parent_company: null
},
{
  description: "",
  headquarters: "Luleå, Sweden",
  homepage: "https://filmpoolnord.se/",
  id: 228,
  logo_path: "/zT2bcTDEbBkfZi2APB8DYJKLIQ3.png",
  name: "Filmpool Nord",
  origin_country: "SE",
  parent_company: null
},
{
  description: "",
  headquarters: "Copenhagen, Denmark",
  homepage: "https://www.nordiskfilm.com",
  id: 235,
  logo_path: "/obOynoztBEhDNfHsDXBqOuQLAZk.png",
  name: "Nordisk Film",
  origin_country: "DK",
  parent_company: null
},
{
  description: "",
  headquarters: "London, England",
  homepage: "http://www.cowboyfilms.co.uk",
  id: 245,
  logo_path: "/9oyhlRJFKrGPmhbRseNbuD9H6dN.png",
  name: "Cowboy Films",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "New York, New York, USA",
  homepage: "http://www.mirabaifilms.com",
  id: 252,
  logo_path: "/iASOYficVcY1QpUOySacOWfrObX.png",
  name: "Mirabai Films",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Potsdam, Germany",
  homepage: "http://www.studiobabelsberg.com",
  id: 264,
  logo_path: "/fA90qwUKgPhMONqtwY60GaHRyrW.png",
  name: "Studio Babelsberg",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "",
  id: 272,
  logo_path: "/5dWI6BucpMxcUdwhp2YfyGtqUPB.png",
  name: "Spelling Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Boca Raton, Florida, USA",
  homepage: "",
  id: 275,
  logo_path: "/2MxNWlN5b3UXt1OfmznsWEQzFwq.png",
  name: "Carolco Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Montréal, Québec, Canada",
  homepage: "http://www.cinemaginaire.com/en",
  id: 280,
  logo_path: "/1rwkrpgsc0pWmkvEOabbPzEsGLi.png",
  name: "Cinémaginaire",
  origin_country: "CA",
  parent_company: null
},
{
  description: "",
  headquarters: "Montréal, Québec, Canada",
  homepage: "http://equinoxefilms.com",
  id: 281,
  logo_path: "/ww3pzkwWwHXOPyqiVzMrbcT6yN2.png",
  name: "Equinoxe Films",
  origin_country: "CA",
  parent_company: null
},
{
  description: "",
  headquarters: "London, England",
  homepage: "http://www.bbc.co.uk/bbcfilms",
  id: 288,
  logo_path: "/wdmwQuV4R1MIr8A78izZkC184uC.png",
  name: "BBC Films",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "London, England",
  homepage: "http://www.ingeniousmedia.co.uk",
  id: 290,
  logo_path: "/Q8mw2AOQQc8Qg0uNwLWq86DVZv.png",
  name: "Ingenious Media",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "Wellington, New Zealand",
  homepage: "https://www.nzfilm.co.nz",
  id: 294,
  logo_path: "/3XuHM8TXG0gDdPM3xJI14gkZbQy.png",
  name: "New Zealand Film Commission",
  origin_country: "NZ",
  parent_company: null
},
{
  description: "",
  headquarters: "Wellington, New Zealand",
  homepage: "https://www.nzonair.govt.nz",
  id: 295,
  logo_path: "/24lAsHZaGi4GzNrWzlkK60HLMBx.png",
  name: "NZ on Air",
  origin_country: "NZ",
  parent_company: null
},
{
  description: "",
  headquarters: "Bristol, England",
  homepage: "http://www.aardman.com/",
  id: 297,
  logo_path: "/ykJbf1z5qIreJrHWfnh1ev1alkD.png",
  name: "Aardman Animations",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "Mexico City, Mexico",
  homepage: "http://www.imcine.gob.mx",
  id: 299,
  logo_path: "/elssmtHcogGtF8Gxokh9phZvLKi.png",
  name: "Instituto Mexicano de Cinematografía",
  origin_country: "MX",
  parent_company: null
},
{
  description: "",
  headquarters: "New York City, New York, USA",
  homepage: "http://www.ifcfilms.com",
  id: 307,
  logo_path: "/gUi3pAUznQJpR296lw4mSVbB7zx.png",
  name: "IFC Films",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Hudson Street, New York, USA",
  homepage: "http://weinsteinco.com/",
  id: 308,
  logo_path: "/vie3EehCIkH4TYWcYEt13uk3puN.png",
  name: "The Weinstein Company",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "http://www.cnc.fr",
  id: 310,
  logo_path: "/4Gp5A4YdjPBfsHT47ngHMaXWmb9.png",
  name: "Centre national du cinéma et de l'image animée",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "http://www.procirep.fr",
  id: 311,
  logo_path: "/cCmkG1WCGLWGwGvbdygtGSmclHq.png",
  name: "PROCIREP",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Nordrhein-Westfalen, Germany",
  homepage: "",
  id: 315,
  logo_path: "/hdu0sVxgtCuQud0xF8ZBiN7hEhY.png",
  name: "Filmstiftung Nordrhein-Westfalen",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "Roma, Italy",
  homepage: "http://www.cinecitta.com",
  id: 317,
  logo_path: "/HJj0J9Tk6AGcLpL4O7mI3bsccM.png",
  name: "Istituto Luce Cinecittà",
  origin_country: "IT",
  parent_company: null
},
{
  description: "",
  headquarters: "Russia",
  homepage: "http://ctb.ru/en/",
  id: 318,
  logo_path: "/q0UG4oZERwIywJdDPF4lRlvdYGW.png",
  name: "CTB Film Company",
  origin_country: "RU",
  parent_company: null
},
{
  description: "",
  headquarters: "Stockholm, Sweden",
  homepage: "http://memfis.se/",
  id: 321,
  logo_path: "/pfp6VWF3tYfOHHVRHpYe2iGcYrf.png",
  name: "Memfis Film",
  origin_country: "SE",
  parent_company: null
},
{
  description: "",
  headquarters: "Stockholm, Sweden",
  homepage: "https://www.nordiskfilm.se/",
  id: 327,
  logo_path: "/vodjjKlAbwGeERPjrAhxZMBGPUc.png",
  name: "Nordisk Film",
  origin_country: "SE",
  parent_company: null
},
{
  description: "",
  headquarters: "Berlin, Germany",
  homepage: "",
  id: 332,
  logo_path: "/a7tPwK3iyyxhRA1Sjavc2xZnIW.png",
  name: "Die Beauftragte der Bundesregierung für Kultur und Medien",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "http://www.originalfilm.com",
  id: 333,
  logo_path: "/5xUJfzPZ8jWJUDzYtIeuPO4qPIa.png",
  name: "Original Film",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Moscow, Russia",
  homepage: "https://en.mosfilm.ru",
  id: 344,
  logo_path: "/xenuUvcunUNpbaDOYGhWZERaym7.png",
  name: "Mosfilm",
  origin_country: "RU",
  parent_company: null
},
{
  description: "",
  headquarters: "São Paulo, Brasil",
  homepage: "http://www.o2filmes.com",
  id: 345,
  logo_path: "/hj2nqoG2F9COm16fqvM0YpY3jL4.png",
  name: "O2 Filmes",
  origin_country: "BR",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "http://radarpictures.com",
  id: 350,
  logo_path: "/l4cEc8UZ3ZrPLisIOh1iYMKwAVP.png",
  name: "Radar Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 356,
  logo_path: "/tSJvuFaLIp7l0ONLUiAHA61GbXu.png",
  name: "TF1 Films Production",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 366,
  logo_path: "/igzzn841L0zoD3JRJfBoYDjw7Ch.png",
  name: "Magellin Entertainment",
  origin_country: null,
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "http://www.mactproductions.com",
  id: 393,
  logo_path: "/48DbAqzDc1ivGZrwGG2UAR70c0W.png",
  name: "MACT Productions",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Australia",
  homepage: "",
  id: 417,
  logo_path: "/w7d3hoHQaC0XwjrxEG1yPeuUhu5.png",
  name: "Australian Film Commission",
  origin_country: "AU",
  parent_company: null
},
{
  description: "",
  headquarters: " Burbank, California, USA",
  homepage: "http://www.marvel.com",
  id: 420,
  logo_path: "/hUzeosd33nzE5MCNsZxCGEKTXaQ.png",
  name: "Marvel Studios",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Beverly Hills, California, USA",
  homepage: "http://phantomfour.com",
  id: 423,
  logo_path: "/uvA6e2O31qaonsbYd8tjvgqmNXh.png",
  name: "Phantom Four",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Burbank, California, USA",
  homepage: "http://www.dccomics.com/",
  id: 429,
  logo_path: "/ocBJG7cGdvde3UDlN0v8BEL5Zuw.png",
  name: "DC Comics",
  origin_country: "US",
  parent_company: null
},{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "",
  id: 435,
  logo_path: "/AjzK0s2w1GtLfR4hqCjVSYi0Sr8.png",
  name: "Di Bonaventura Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Burbank, California, USA",
  homepage: "http://1492pictures.com",
  id: 436,
  logo_path: "/A7WCkG3F0NFvjGCwUnclpGdIu9E.png",
  name: "1492 Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Borehamwood, Hertfordshire, England",
  homepage: "",
  id: 437,
  logo_path: "/nu20mtwbEIhUNnQ5NXVhHsNknZj.png",
  name: "Heyday Films",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "Helsinki, Finland",
  homepage: "http://kinoproduction.fi/",
  id: 440,
  logo_path: "/z10otS2BrUXXlIH5zGBP5dnhTPe.png",
  name: "Kinoproduction",
  origin_country: "FI",
  parent_company: null
},
{
  id: 443,
  name: "Big Talk Productions",
  origin_country: "GB",
  parent_company: null
},
{
  id: 444,
  logo_path: "/42UPdZl6B2cFXgNUASR8hSt9mpS.png",
  name: "Dune Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 446,
  logo_path: "/d9EQKqrGy25s61Bsh10nO0BfzPF.png",
  name: "thinkfilm",
  origin_country: "US",
  parent_company: null
},
{
  id: 451,
  logo_path: "/5uHjCNDC7lV8GeAJqSMwgGGqndk.png",
  name: "Medienboard Berlin-Brandenburg",
  origin_country: "DE",
  parent_company: null
},
{
  id: 468,
  logo_path: "/42mtaDQPu1OTmfrvmwq6OsnHLPG.png",
  name: "AAA Production",
  origin_country: "FR",
  parent_company: null
},
{
  id: 483,
  logo_path: "/mCEJD7utltKsFY1fPVM4uWQGmvz.png",
  name: "Praesens-Film AG",
  origin_country: "CH",
  parent_company: null
},
{
  id: 485,
  logo_path: "/tVOP0mIeoYLua4Rw66OYNzitrrI.png",
  name: "Vinyl Films",
  origin_country: "US",
  parent_company: null
},
{
  id: 487,
  logo_path: "/x3BUIowxU2skXOpnOeOkl7kIYDo.png",
  name: "Česká televize",
  origin_country: "CZ",
  parent_company: null
},
{
  id: 490,
  logo_path: null,
  name: "New Regency Productions",
  origin_country: null,
  logo_path: "/7PzJdsLGlR7oW4J0J5Xcd0pHGRg.png",
},
{
  id: 491,
  logo_path: "/rUp0lLKa1pr4UsPm8fgzmnNGxtq.png",
  name: "Summit Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 494,
  logo_path: "/ioc65azmsAeL1XQN4dFnrpdJoMO.png",
  name: "AVCO Embassy Pictures",
  origin_country: "US",
  parent_company: null
},
{
  id: 497,
  logo_path: "/pMyhOBd3sCiLzBlmIopdJkcUFtn.png",
  name: "Revolution Studios",
  origin_country: null,
  parent_company: null
},
{
  id: 507,
  logo_path: "/z7H707qUWigbjHnJDMfj6QITEpb.png",
  name: "Atlas Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 508,
  logo_path: "/7PzJdsLGlR7oW4J0J5Xcd0pHGRg.png",
  name: "Regency Enterprises",
  origin_country: "US",
  parent_company: null
},
{
  id: 520,
  logo_path: "/pU7YTI9FfrICurXpl5V9TfCO0oJ.png",
  name: "Pacific Data Images",
  origin_country: "US",
  parent_company: null
},
{
  id: 521,
  logo_path: "/cHvwSfUAG1KPkiwdBDwtn5ahX0P.png",
  name: "DreamWorks Animation",
  origin_country: "US",
  parent_company: null
},
{
  id: 528,
  logo_path: "/fO3Aof3lXQclYpBByYC8aneTXwA.png",
  name: "Bandai Visual",
  origin_country: "JP",
  parent_company: null
},
{
  id: 529,
  logo_path: "/rwB6w2aPENQbx756pBWSw44Ouk.png",
  name: "Production I.G",
  origin_country: "JP",
  parent_company: null
},
{
  id: 551,
  logo_path: "/fQp9uyicPHVS4gd2mgUoZOyJ0ss.png",
  name: "Mandalay Pictures",
  origin_country: "US",
  parent_company: null
},
{
  id: 552,
  logo_path: "/9dGdLfm3GteWeUDtD9c9tvlidUG.png",
  name: "Dark Horse Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 559,
  logo_path: "/rzgMLzPgJ2ZBYnlVwNi8ZDfOMwo.png",
  name: "TriStar Pictures",
  origin_country: "US",
  parent_company: null
},
{
  id: 562,
  logo_path: "/k3NsSdV854UX4zEReX1dl1Psxbb.png",
  name: "Appian Way",
  origin_country: "US",
  parent_company: null
},
{
  id: 574,
  logo_path: "/iB6GjNVHs5hOqcEYt2rcjBqIjki.png",
  name: "Lightstorm Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 581,
  logo_path: "/pzJLNyKypqwAgLR4OjmaxA5WEjm.png",
  name: "UGC",
  origin_country: "FR",
  parent_company: null
},
{
  id: 587,
  logo_path: "/6UIpEURdjnmcJPwgTDRzVRuwADr.png",
  name: "ARTE",
  origin_country: "DE",
  parent_company: null
},
{
  id: 588,
  logo_path: "/6mWg9rdVSj8gwgMiOmZH4iBCcMm.png",
  name: "MDR",
  origin_country: "DE",
  parent_company: null
},
{
  id: 591,
  logo_path: "/pvtj07ED3TDkUPqPXa75Ic5w9Jg.png",
  name: "France 3 Cinéma",
  origin_country: "FR",
  parent_company: null
},
{
  id: 602,
  logo_path: "/pVsXRFbYVDe5BhsATCAh1rt5F0k.png",
  name: "DEFA",
  origin_country: "DE",
  parent_company: null
},
{
  id: 608,
  logo_path: "/dD2Do4GHXAql5c4LjXCbEOvxbFg.png",
  name: "Dor Film Production Company",
  origin_country: "AT",
  parent_company: null
},
{
  id: 616,
  logo_path: "/aeBPwUMUqIOFnt3Fxv9fC91hBuq.png",
  name: "Eskwad",
  origin_country: "FR",
  parent_company: null
},
{
  id: 647,
  name: "Sony Music Entertainment Visual Works Inc.",
  origin_country: null,
},
{
  id: 648,
  name: "Sony Music Entertainment Japan",
  origin_country: "JP",
  parent_company: null
},
{
  
  id: 656,
  homepage: "https://www.metrofilms.com",
  name: "Metropolitan Filmexport",
  origin_country: "FR",
  parent_company: null
},
{
  id: 670,
  logo_path: "/rRGi5UkwvdOPSfr5Xf42RZUsYgd.png",
  name: "Walt Disney Television",
  origin_country: "US",
},
{
  id: 678,
  logo_path: "/AbIc38dGx4b8dhKS7oeRL6aXFDv.png",
  name: "Turner Network Television",
  origin_country: "US",
  parent_company: null
},
{
  id: 686,
  logo_path: "/iTxmqi0ldTpKvYAoQuWgHnZ6aXN.png",
  name: "Tiger Aspect Productions",
  origin_country: "GB",
  parent_company: null
},
{
  id: 688,
  logo_path: "/65PkdDSyh6fwXgwg47x73pvgWiW.png",
  origin_country: "US",
  parent_company: null
},
{
  id: 694,
  logo_path: "/5LEHONGkZBIoWvp1ygHOF8iyi1M.png",
  name: "StudioCanal",
  origin_country: "FR",
  parent_company: null
},
{
  id: 703,
  logo_path: "/lMV4teVPQWJxIaiDsAsU7Vdh1iC.png",
  name: "Razor Film Produktion",
  origin_country: "DE",
  parent_company: null
},
{
  id: 711,
  logo_path: "/tEiIH5QesdheJmDAqQwvtN60727.png",
  name: "Fox 2000 Pictures",
  origin_country: "US",
  parent_company: null
},
{
  id: 726,
  logo_path: "/hHaQQgxqg2NohqZSxbMTB9E483m.png",
  name: "Haut et Court",
  origin_country: "FR",
  parent_company: null
},
{
  id: 729,
  logo_path: "/hNxGdbddbsDDnEWJ7RNLcGCRSLQ.png",
  name: "Why Not Productions",
  origin_country: "FR",
  parent_company: null
},
{
  id: 737,
  logo_path: "/i1jNMQ9eNsq0wqpIJjyAkzS9NYq.png",
  name: "Sidney Kimmel Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 744,
  logo_path: "/iPQvLZPw7e3T3No0akup0F9o8nV.png",
  name: "Diaphana Films",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Hollywood, Los Angeles, California, USA",
  homepage: "",
  id: 746,
  logo_path: "/kc7bdIVTBkJYy9aDK1QDDTAL463.png",
  name: "MTV Films",
  origin_country: "US",
  parent_company: null
},
{
  id: 758,
  logo_path: "/fft3jrctrZNcgAxgN1w5Givtzip.png",
  name: "TV 2",
  origin_country: "DK",
  parent_company: null
},
{
  id: 779,
  logo_path: "/41uIo51zJKwD41dBY6ENJmELGga.png",
  name: "Lucky Red",
  origin_country: "IT",
  parent_company: null
},
{
  id: 787,
  logo_path: "/cCefBs1t7jxtiz3eCxBp9yxrxGx.png",
  name: "3 Arts Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 789,
  logo_path: "/rQ0fru0nm1oCsz2npnAgXEl11AH.png",
  name: "Pallas Film",
  origin_country: "DE",
  parent_company: null
},
{
  id: 790,
  logo_path: "/k0MnHFovKIeev0ANR0Ww6HO6tfF.png",
  name: "Samsa Film",
  origin_country: "LU",
  parent_company: null
},
{
  id: 792,
  logo_path: "/cRhBQP1FFNugNxKkO1pUgeD2Rkr.png",
  name: "RTBF",
  origin_country: "BE",
  parent_company: null
},
{
  id: 793,
  logo_path: "/10DhIXAmAixQvBOsjZ1MOeSRyUC.png",
  name: "Galatée Films",
  origin_country: "FR",
  parent_company: null
},
{
  id: 798,
  logo_path: "/nQgX1MOLySgug7FDONdIkht3xob.png",
  name: "Samuel Goldwyn Company",
  origin_country: "US",
  parent_company: null
},
{
  id: 803,
  logo_path: "/jEMVaCuEjQ3lzkhakWDKNVjwd9Q.png",
  name: "Alliance Atlantis Communications",
  origin_country: null,
  parent_company: null
},
{
  id: 806,
  logo_path: "/kcNh09qqR2Pkw1JAzRW4CommrW4.png",
  name: "Téléfilm Canada",
  origin_country: "CA",
  parent_company: null
},
{
  description: "",
  headquarters: "Canada",
  homepage: "http://www.themovienetwork.ca/",
  id: 808,
  logo_path: "/4L1apH72jCx6Z5qyH7UOJUDlRoF.png",
  name: "The Movie Network",
  origin_country: "CA",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "http://www.marsfilms.com",
  id: 819,
  logo_path: "/cEqVIluQuO1ubtID8RvOem4ZiIg.png",
  name: "Mars Films",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Toronto, Ontario, Canada",
  homepage: "https://www.serendipitypoint.com/",
  id: 805,
  logo_path: null,
  name: "Serendipity Point Films",
  origin_country: "CA",
  parent_company: null
},
{
  description: "",
  headquarters: "Japan",
  homepage: "http://www.happinet-p.com",
  id: 822,
  logo_path: null,
  name: "Happinet Pictures",
  origin_country: "JP",
  parent_company: null
},
{
  description: "",
  headquarters: "Munich, Germany",
  homepage: "http://www.telepool.de/",
  id: 823,
  logo_path: null,
  name: "Telepool",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "",
  id: 829,
  logo_path: "/mzpAmEQ5P1gFvdRoNyCk9q8ngiv.png",
  name: "Vertigo Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "https://elzevirfilms.fr",
  id: 836,
  logo_path: "/93zzVd8ijSExx6DhVI4Xqj8WmOJ.png",
  name: "Elzévir Films",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "USA",
  homepage: "",
  id: 838,
  logo_path: "/tcW3UqV46Mdq6GyaS1ydEDocEDF.png",
  name: "Paramount Vantage",
  origin_country: "US",
  parent_company: {
    name: "Paramount",
    id: 4,
    logo_path: "/fycMZt242LVjagMByZOLUGbCvv3.png"
  }
},
{
  description: "",
  headquarters: "Los Angeles, California USA",
  homepage: "http://www.2929productions.com/",
  id: 846,
  logo_path: null,
  name: "2929 Productions",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Strasbourg, France",
  homepage: "https://www.coe.int/en/web/eurimages",
  id: 850,
  logo_path: "/aF7qajGJGtMpdrtvssM9g90YanX.png",
  name: "Eurimages",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, Ile-de-France, France",
  homepage: "http://www.europacorp.com/",
  id: 854,
  logo_path: "/2Q89KvzxTKB5BAv9RqFIPI1qb7E.png",
  name: "Sofica Europacorp",
  origin_country: null,
  parent_company: {
    name: "EuropaCorp",
    id: 6896,
    logo_path: "/2Q89KvzxTKB5BAv9RqFIPI1qb7E.png"
  }
},
{
  description: "",
  headquarters: "Berlin, Germany",
  homepage: "http://www.wildbunch.biz",
  id: 856,
  logo_path: "/z0vTTWBhZggM09oZWSY3hbXgPKv.png",
  name: "Wild Bunch",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "https://3b-productions.com",
  id: 858,
  logo_path: "/u7ffsNHEJg2ThDJMNK7nNOCdvB2.png",
  name: "Tessalit Productions",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Ixelles, Belgium",
  homepage: "http://sagafilm.be",
  id: 859,
  logo_path: "/9S6ZpaAui6o5NmPossK7SUK8sR9.png",
  name: "Saga Film",
  origin_country: "BE",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "",
  id: 860,
  logo_path: "/aWrTeKCGu9jjsiiVSDsALC3vxu4.png",
  name: "Celluloid Dreams",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Santa Monica, California, USA",
  homepage: "http://kennedymarshall.com/",
  id: 862,
  logo_path: "/udTjbqPmcTbfrihMuLtLcizDEM1.png",
  name: "The Kennedy/Marshall Company",
  origin_country: "US",
  parent_company: null
},
{
  id: 863,
  logo_path: null,
  name: "Mantarraya Producciones",
  origin_country: "MX",
  parent_company: null
},
{
  id: 864,
  logo_path: null,
  name: "No Dream Cinema",
  origin_country: "MX",
  parent_company: null
},
{
  description: "",
  headquarters: "Jung, Seoul, South Korea",
  homepage: "http://www.cinemaservice.com/",
  id: 868,
  logo_path: "/pWznyKg90dGoFpWQ5yAQ0Wdvde8.png",
  name: "Cinema Service",
  origin_country: "KR",
  parent_company: null
},
{
  description: "",
  headquarters: "Chiyoda, Tokyo Prefecture, Japan",
  homepage: "https://www.toho.co.jp",
  id: 882,
  logo_path: "/lYCOp17DBEjFD1UygdRor98PVWR.png",
  name: "Toho Company, Ltd.",
  origin_country: "JP",
  parent_company: null
},
{
  description: "",
  headquarters: "Rome, Italy",
  homepage: "",
  id: 896,
  logo_path: "/8mgDIRTMIfjc5sfjXSN4NCz7vmQ.png",
  name: "RAI 2",
  origin_country: "IT",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "",
  id: 897,
  logo_path: "/h9CSdF6fjB5bEB7qWLM5Ze4ZfrQ.png",
  name: "Taurus Films",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Culver City, California, USA",
  homepage: "",
  id: 898,
  logo_path: "/pBh5kde6mhGEMglYLwCdFnqK5zh.png",
  name: "Lorimar Productions",
  origin_country: null,
  parent_company: null
},
{
  description: "",
  headquarters: "USA",
  homepage: "https://revfilmtv.com",
  id: 906,
  logo_path: "/gN893tmlrcVvWiWCBZEVAiZHpvT.png",
  name: "Revelations Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Culver City, California, United States",
  homepage: "http://www.overbrookent.com",
  id: 907,
  logo_path: "/ca5SWI5uvU985f8Kbb4xc8AmVWH.png",
  name: "Overbrook Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "http://roadsideattractions.com",
  id: 911,
  logo_path: null,
  name: "Roadside Attractions",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Grünwald, Germany",
  homepage: "https://www.concorde-movie-lounge.de/kino/uebersicht/",
  id: 913,
  logo_path: "/2WhkaU4zJ3y1ivimjQ7Cl490h71.png",
  name: "Concorde Filmverleih",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "Burbank, California, USA",
  homepage: "",
  id: 915,
  logo_path: "/4neXXpjSJDZPBGBnfWtqysB5htV.png",
  name: "Hollywood Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "New York City, New York, USA",
  homepage: "http://www.senartfilms.com",
  id: 922,
  logo_path: null,
  name: "SenArt Films",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Burbank, California, USA",
  homepage: "http://www.legendary.com/",
  id: 923,
  logo_path: "/5UQsZrfbfG2dYJbx8DxfoTr2Bvu.png",
  name: "Legendary Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "",
  id: 925,
  logo_path: "/dIb9hjXNOkgxu4kBWdIdK8nM4w.png",
  name: "Nu Image",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Hongo, Bunkyo-ku. Tokyo, Japan",
  homepage: "http://www.nikkatsu.com",
  id: 955,
  logo_path: "/5xnXD3PJI1HqOJceSAKZ3fDqO1V.png",
  name: "Nikkatsu Corporation",
  origin_country: "JP",
  parent_company: null
},
{
  id: 880,
  logo_path: null,
  name: "Daiei Motion Picture Co., Ltd.",
  origin_country: "JP",
  parent_company: null
},
{
  id: 958,
  logo_path: null,
  name: "Japan America Picture Company",
  origin_country: null,
  parent_company: null
},
{
  id: 983,
  logo_path: null,
  name: "Parallax Pictures",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "New York City, New York",
  homepage: "",
  id: 1002,
  logo_path: null,
  name: "Eureka Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Oslo, Norway",
  homepage: "http://www.filmkameratene.no/",
  id: 1003,
  logo_path: null,
  name: "Filmkameratene",
  origin_country: "NO",
  parent_company: null
},
{
  description: "",
  headquarters: "Pozuelo de Alarcón, Spain",
  homepage: "http://www.rtve.es",
  id: 981,
  logo_path: "/pkrdO9ykplO4Zc8edikoSX5APUN.png",
  name: "TVE",
  origin_country: "ES",
  parent_company: null
},
{
  description: "",
  headquarters: "Stockholm, Sweden",
  homepage: "https://www.colinnutley.com/",
  id: 1005,
  logo_path: "/aNvdEYfswPjbZoZiprCqDUxX6SB.png",
  name: "Sweetwater Production",
  origin_country: "SE",
  parent_company: null
},
{
  id: 1020,
  logo_path: "/cIuABRK5kxJ930toE50m2USToA7.png",
  name: "Millennium Films",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1021,
  logo_path: null,
  name: "Zeitsprung Entertainment",
  origin_country: null,
  parent_company: "DE"
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1023,
  logo_path: null,
  name: "Nelvana Limited",
  origin_countr: "CA",
  parent_company: null
},
{
  description: "Madrid, Spain",
  headquarters: "",
  homepage: "",
  id: 1024,
  logo_path: null,
  name: "Amiguetes Entertainment S.L.",
  origin_country: "ES",
  parent_company: null
},
{
  description: "",
  headquarters: "Madrid",
  homepage: "http://www.lolafilms.com/en-US",
  id: 1025,
  logo_path: null,
  name: "Lolafilms",
  origin_country: "ES",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1026,
  logo_path: null,
  name: "Cartel",
  origin_country: "ES",
  parent_company: null
},
{
  description: "",
  headquarters: "Madrid, Spain",
  homepage: "",
  id: 1027,
  logo_path: null,
  name: "Rocabruno S.A.",
  origin_country: "ES",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "http://www.gmtproductions.fr/en",
  id: 1028,
  logo_path: null,
  name: "GMT Productions",
  origin_country: "FR",
  parent_company: null
},
{
  id: 10289,
  logo_path: "/4lXJcFjACjb34LF78AUjEz4FtB9.png",
  name: "DMG Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  id: 1030,
  logo_path: "/bus7KzJshT0VMXuKR7dwK5bqPSO.png",
  name: "Magnolia Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1031,
  logo_path: null,
  name: "Filmazure",
  origin_country: "FR", // ?
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1032,
  logo_path: null,
  name: "Pirol Stiftung",
  origin_country: null,
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1033,
  logo_path: null,
  name: "Victoires International",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "",
  id: 1034,
  logo_path: null,
  name: "Viva Pictures",
  origin_country: "US",
  parent_company: null
},
{
  id: 1038,
  logo_path: "/o62j8ZNXmRTrq6ThviFWiL9zb8J.png",
  name: "Bazelevs Production",
  origin_country: "RU",
  parent_company: null
},
{
  id: 1039,
  logo_path: "/vTDwphEW5Ikiqu6UxrRCzhfFcVo.png",
  name: "First Channel",
  origin_country: "RU",
  parent_company: null
},
{
  id: 1040,
  logo_path: "/zFtcBrG98D0Ftwn9tXwRI03iQzd.png",
  name: "Tabbak",
  origin_country: "RU",
  parent_company: null
},
{
  headquarters: "Roma, Italy",
  id: 1042,
  logo_path: null,
  name: "Cinecittà",
  origin_country: "IT",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1043,
  logo_path: null,
  name: "Revere Pictures",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1044,
  logo_path: null,
  name: "Franton Production",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "London, England",
  homepage: "",
  id: 1045,
  logo_path: null,
  name: "Marmot Tandy Productions",
  origin_country: "GB",
  parent_company: null
},
{
  id: 1063,
  logo_path: "/fpVBhNnopOZwGuF0gg99oBHp1ht.png",
  name: "Brightlight Pictures",
  origin_country: "CA",
  parent_company: null
},
{
  id: 1077,
  logo_path: "/byWGD7MGMgdfy7q4liYpoN4ZqN5.png",
  name: "GONZO",
  origin_country: "JP",
  parent_company: null
},
{
  id: 1078,
  logo_path: null,
  name: "Shanghai Film Studio",
  origin_country: "CN",
  parent_company: null
},
{
  id: 1079,
  logo_path: null,
  name: "Xstream Pictures",
  origin_country: "CN",
  parent_company: null
},
{
  description: "",
  headquarters: "Germany",
  homepage: "",
  id: 1080,
  logo_path: "/6bZ0BiLDzCZSqVCjiSqweWwp9Ew.png",
  name: "Beta Film",
  origin_country: "DE",
  parent_company: null
},
{
  id: 1081,
  logo_path: "/vfcpaPf6WktaCIHqF4FJAcek8q2.png",
  name: "CBS Television Studios",
  origin_country: "US",
  parent_company: null
},

{
  description: "",
  headquarters: "Rome, Italy",
  homepage: "https://www.luxvide.it/en/",
  id: 1082,
  logo_path: null,
  name: "Lux Vide",
  origin_country: "IT",
  parent_company: null
},
{
  description: "",
  headquarters: "Cologne, Germany",
  homepage: "",
  id: 1084,
  logo_path: null,
  name: "Colonia Media",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "New York, USA",
  homepage: "",
  id: 1087,
  logo_path: null,
  name: "Aurora Productions",
  origin_country: "US",
  parent_company: null
},
{
  id: 1088,
  logo_path: "/9WOE5AQUXbOtLU6GTwfjS8OMF0v.png",
  name: "Alcon Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1089,
  logo_path: null,
  name: "Witt/Thomas Productions",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Bromberg, Germany",
  homepage: "",
  id: 1090,
  logo_path: null,
  name: "Katrin Seybold Film GmbH",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1091,
  logo_path: null,
  name: "Fuzzi Film Produktion",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California",
  homepage: "http://www.mockingbirdpictures.com/",
  id: 1092,
  logo_path: "/dU2S6qBrsMkBFFkAbcUnJ7p3Izh.png",
  name: "Mockingbird Pictures",
  origin_country: "US",
  parent_company: null
},
{
  id: 1093,
  logo_path: "/7GreTaRypmbOBoFYoCCRkYH3Wvc.png",
  name: "Shoreline Entertainment",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Copenhagen Denmark",
  homepage: "https://homerun.media/",
  id: 1094,
  logo_path: null,
  name: "Homerun Productions",
  origin_country: "DK",
  parent_company: null
},
{
  description: "",
  headquarters: "London, England",
  homepage: "",
  id: 1095,
  logo_path: null,
  name: "Portman Entertainment Group",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1096,
  logo_path: null,
  name: "Rich Pickings",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1097,
  logo_path: null,
  name: "Sky Pictures",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1098,
  logo_path: null,
  name: "Wave Pictures",
  origin_country: "",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1099,
  logo_path: null,
  name: "AJYM-Films",
  origin_country: null,
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1100,
  logo_path: null,
  name: "Angel Baby Entertainment",
  origin_country: null,
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1102,
  logo_path: null,
  name: "Producciones Anhelo",
  origin_country: "ES",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1103,
  logo_path: null,
  name: "Maverik Motion Pictures",
  origin_country: null,
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1104,
  logo_path: null,
  name: "Twin Track Films",
  origin_country: "X",
  parent_company: null
},
{
  description: "",
  headquarters: "München, Germany",
  homepage: "https://www.hv-entertainment.com/",
  id: 1105,
  logo_path: null,
  name: "Hofmann & Voges Entertainment",
  origin_country: "DE",
  parent_company: null
},
{
  id: 1115,
  logo_path: "/ntH7T5gsN6wtyrfHGHJDTuneQ7o.png",
  name: "M6 Films",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1116,
  logo_path: null,
  name: "Lonely Pictures",
  origin_country: null,
  parent_company: null
},
{
  id: 1117,
  logo_path: "/2X2uFeObxawiAajNDOf3Mhri5Wg.png",
  name: "Antenne 2",
  origin_country: "FR",
  parent_company: null
},
{
  id: 1219,
  logo_path: "/6OGqCShROjIvmBOfRbeUsn7im93.png",
  name: "Baby Cow Productions",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "Madrid, Spain",
  homepage: "",
  id: 1500,
  logo_path: null,
  name: "Copercines",
  origin_country: "ES",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1506,
  logo_path: "/kn81D1txpA73a90z7CWJPvlP6iP.png",
  name: "Filmation Associates",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "London, England",
  homepage: "http://www.wildgazefilms.co.uk",
  id: 1508,
  logo_path: null,
  name: "Wildgaze Films",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "Burbank, California",
  homepage: "",
  id: 1512,
  logo_path: null,
  name: "John Wells Productions",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Portugal",
  homepage: "",
  id: 1519,
  logo_path: null,
  name: "A&B Produções",
  origin_country: "PT",
  parent_company: null
},
{
  description: "",
  headquarters: "Germany",
  homepage: "",
  id: 1521,
  logo_path: null,
  name: "Artemis Film",
  origin_country: "DE",
  parent_company: null
},
{
  description: "",
  headquarters: "London, England",
  homepage: "http://nealstreetproductions.com",
  id: 1522,
  logo_path: "/8uaoEVgNxFH0R94O53gUiByahVr.png",
  name: "Neal Street Productions",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "",
  id: 1523,
  logo_path: null,
  name: "Ciné Valse",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "Paris, France",
  homepage: "http://www.productionsroitfeld.fr/",
  id: 1527,
  logo_path: null,
  name: "Les Productions Jacques Roitfeld",
  origin_country: "FR",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "",
  id: 1531,
  logo_path: null,
  name: "Smart Egg Pictures",
  origin_country: "GB",
  parent_company: null
},
{
  description: "",
  headquarters: "",
  homepage: "https://www.indigofilm.it/",
  id: 1533,
  logo_path: "/6ZdM1yg1LXtzS5zpuZPtZsn9YdA.png",
  name: "Indigo Film",
  origin_country: "IT",
  parent_company: null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1538,
  "logo_path": "/3q7NjXSLVUPQ24CG3zrBPK7GQqH.png",
  "name": "Comedy Central",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1540,
  "logo_path": null,
  "name": "Société Nouvelle des Films",
  "origin_country": "FR",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1541,
  "logo_path": null,
  "name": "Terra Film Produktion",
  "origin_country": "",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1545,
  "logo_path": null,
  "name": "Roxbury Productions",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "http://www.universalpictures.fr/",
  "id": 1546,
  "logo_path": "/mGbYwpo7isFx7RyRm26qvuSFTbw.png",
  "name": "Universal Pictures France",
  "origin_country": "FR",
  "parent_company": {
    "name": "Universal Pictures",
    "id": 33,
    "logo_path": "/mGbYwpo7isFx7RyRm26qvuSFTbw.png"
  }
},
{
  "description": "",
  "headquarters": "Munich, Germany",
  "homepage": "",
  "id": 1548,
  "logo_path": null,
  "name": "Franz Seitz Filmproduktion",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1549,
  "logo_path": null,
  "name": "Opera Film Produzione",
  "origin_country": "FR",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1550,
  "logo_path": null,
  "name": "Evamere Entertainment",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1553,
  "logo_path": null,
  "name": "Selznick International Pictures",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1554,
  "logo_path": null,
  "name": "Transatlantic Pictures",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1555,
  "logo_path": null,
  "name": "G.W. Films",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Los Angeles, California, USA",
  "homepage": "https://20thtv.com",
  "id": 1556,
  "logo_path": "/31h94rG9hzjprXoYNy3L1ErUya2.png",
  "name": "20th Century Fox Television",
  "origin_country": "US",
  "parent_company": {
    "name": "20th Century Fox",
    "id": 25,
    "logo_path": "/nM2MfoMqzJQRiSynsDabOtFKetD.png"
  }
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1557,
  "logo_path": "/ccz9bqCu3jSFKbPFnfWmjAKZLBL.png",
  "name": "The Mark Gordon Company",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1558,
  "logo_path": "/wwaKUcOENHix2jxLfFBfNkCtOEQ.png",
  "name": "Touchstone Television",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1559,
  "logo_path": null,
  "name": "Les Films de la Seine",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1560,
  "logo_path": null,
  "name": "Roth-Arnold Productions",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 1561,
  "logo_path": null,
  "name": "Pegasus Film Partners",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "http://www.dsp.tv/",
  "id": 2015,
  "logo_path": null,
  "name": "Darlow Smithson Productions",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "https://www.ffa.de",
  "id": 2026,
  "logo_path": "/zt6vosdjUjueuSwSPHfyiCbb547.png",
  "name": "FFA",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2027,
 "logo_path": "/rvHnU0XJniilOjf6IK9ZdXTUKE5.png",
  "name": "3sat",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Málaga, Spain",
  "homepage": "",
  "id": 2029,
  "logo_path": null,
  "name": "Estudios Picasso",
  "origin_country": "ES",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2032,
  "logo_path": null,
  "name": "Orange Pictures",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2033,
  "logo_path": null,
  "name": "Neue Filmproduktion TV",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2036,
  "logo_path": null,
  "name": "Y Filme Directors Pool",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2047,
  "logo_path": null,
  "name": "U5 Filmproduktion GmbH",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2053,
  "logo_path": null,
  "name": "Grosvenor Park Media",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "London, England",
  "homepage": "http://www.skylinefilms.co.uk",
  "id": 2055,
  "logo_path": null,
  "name": "Skyline Films",
  "origin_country": "GB",
  "parent_company": null
},

{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2060,
  "logo_path": null,
  "name": "Continental Film",
  "origin_country": "FR",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2063,
  "logo_path": null,
  "name": "Power",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Vilnius, Lithuania",
  "homepage": "https://www.lfs.lt/",
  "id": 2064,
  "logo_path": "/4cxlmKotK2vAm0TKcGrSGyhxD07.png",
  "name": "Lithuanian Film Studio",
  "origin_country": "LT",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Los Angeles, California",
  "homepage": "https://scoutproductionsinc.com",
  "id": 2065,
  "logo_path": "/uzs8PUkkOAKczujYjv91DVNRMyJ.png",
  "name": "Scout Productions",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Berlin",
  "homepage": "https://www.rbb24.de",
  "id": 2067,
  "logo_path": "/y5knLIUjYsKBIlM4W0dLruWwYaC.png",
  "name": "RBB",
  "origin_country": "DE",
  "parent_company": {
    "name": "ARD",
    "id": 1251,
    "logo_path": "/ucgmv8vBIA3Tr2VbqQ1NKYgkTsN.png"
  }
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2069,
  "logo_path": null,
  "name": "Allmedia Pictures GmbH",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2071,
  "logo_path": null,
  "name": "Mecom Movie GmbH",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "https://www.kadokawa-pictures.jp",
  "id": 2073,
  "logo_path": "/bkpWpkSDfNG1HxJnjruVKHXBi7J.png",
  "name": "Kadokawa Pictures",
  "origin_country": "JP",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2075,
  "logo_path": null,
  "name": "MMG Film & TV Production",
  "origin_country": "BE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2076,
  "logo_path": null,
  "name": "Gloria",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2083,
  "logo_path": null,
  "name": "Maximage GmbH",
  "origin_country": "CH",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2084,
  "logo_path": null,
  "name": "Gate Filmproduktion",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2089,
  "logo_path": null,
  "name": "Samuels Media",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Los Angeles, California",
  "homepage": "http://www.mpcafilm.com",
  "id": 2090,
  "logo_path": "/jYlUttNqcN5u1pzMQrh5AEhZ27t.png",
  "name": "Motion Picture Corporation of America",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "New York City, New York",
  "homepage": "",
  "id": 2092,
  "logo_path": null,
  "name": "Mike Zoss Productions",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2102,
  "logo_path": null,
  "name": "Frankovich Productions",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2104,
  "logo_path": null,
  "name": "Tangled Web Productions",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Copenhagen, Denmark",
  "homepage": "",
  "id": 2105,
  "logo_path": null,
  "name": "Thura Film",
  "origin_country": "DK",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2106,
  "logo_path": null,
  "name": "Saban Entertainment",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2108,
  "logo_path": null,
  "name": "Battleplan Productions",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2110,
  "logo_path": null,
  "name": "Inter West Film",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2113,
  "logo_path": null,
  "name": "Cinéfilm AG",
  "origin_country": "CH",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Californa, USA",
  "homepage": "",
  "id": 2115,
  "logo_path": null,
  "name": "Uranos Cinematografica",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2124,
  "logo_path": null,
  "name": "Melvin Simon Productions",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2125,
  "logo_path": null,
  "name": "Phoenix Film",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2127,
  "logo_path": null,
  "name": "Uco-Film GmbH",
  "origin_country": "SE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Mendoza, Argentina",
  "homepage": "",
  "id": 2129,
  "logo_path": null,
  "name": "Film Andes",
  "origin_country": "AR",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2132,
  "logo_path": null,
  "name": "Veit Helmer-Filmproduktion",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "New York, New York, USA",
  "homepage": "",
  "id": 2139,
  "logo_path": null,
  "name": "Kulture Machine",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Mumbai, India",
  "homepage": "http://akpfilms.com",
  "id": 2140,
  "logo_path": null,
  "name": "Aamir Khan Productions",
  "origin_country": "IN",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "India",
  "homepage": "",
  "id": 2141,
  "logo_path": null,
  "name": "Kaleidoscope Entertainment",
  "origin_country": "IN",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Germany",
  "homepage": "",
  "id": 2145,
  "logo_path": null,
  "name": "Göttinger-Film-Atelier GmbH",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Toronto, Canada",
  "homepage": "",
  "id": 2146,
  "logo_path": null,
  "name": "David Hamilton Productions",
  "origin_country": "CA",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Beverly Hills, California",
  "homepage": "http://www.echolakeentertainment.com",
  "id": 2147,
  "logo_path": "/yV2P6SlxuicJTwUvUUqoOBAEreC.png",
  "name": "Echo Lake Entertainment",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2150,
  "logo_path": null,
  "name": "GreeneStreet Films",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2151,
  "logo_path": null,
  "name": "Fugitive Films",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2153,
  "logo_path": null,
  "name": "Saticoy Productions",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Dallas, Texas, US",
  "homepage": "",
  "id": 2155,
  "logo_path": null,
  "name": "Norris Brothers Entertainment",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2156,
  "logo_path": null,
  "name": "Super-Film GmbH",
  "origin_country": "AT",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Culver City, California, US",
  "homepage": "http://www.hal-roach.com/",
  "id": 2159,
  "logo_path": null,
  "name": "Hal Roach Studios",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2161,
  "logo_path": "/kaHPCUD2nQ1DGWDAH3zbYVCkTae.png",
  "name": "CBS Productions",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2163,
  "logo_path": null,
  "name": "Optimus Productions",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2167,
  "logo_path": null,
  "name": "Eran Riklis Productions Ltd.",
  "origin_country": "Israel",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 2168,
  "logo_path": null,
  "name": "Cinemavault Releasing",
  "origin_country": "Canada",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Hamburg",
  "homepage": "http://www.magnoliafilm.de",
  "id": 2169,
  "logo_path": null,
  "name": "Magnolia Filmproduktion",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Hamburg",
  "homepage": "http://www.magnoliafilm.de",
  "id": 2169,
  "logo_path": null,
  "name": "Magnolia Filmproduktion",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5001,
  "logo_path": null,
  "name": "Conacite Dos",
  "origin_country": "MX",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "London, England, UK",
  "homepage": "http://www.bedlamproductions.co.uk",
  "id": 5005,
  "logo_path": "/letEuggPWBjO3HVu1QKAy5DoJZU.png",
  "name": "Bedlam Productions",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5006,
  "logo_path": null,
  "name": "Exposed Film Productions AS",
  "origin_country": "NO",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5007,
  "logo_path": null,
  "name": "Eagle Rock Film & TV Productions",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Krefeld, Germany",
  "homepage": "",
  "id": 5011,
  "logo_path": null,
  "name": "Becker & Häberle Filmproduktion GmbH",
  "origin_country": "DE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5013,
  "logo_path": null,
  "name": "Friland AS",
  "origin_country": "NO",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5019,
  "logo_path": null,
  "name": "Wagons East N.V.",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Dublin, Ireland",
  "homepage": "",
  "id": 5020,
  "logo_path": null,
  "name": "BrownBag Productions (II)",
  "origin_country": "IE",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5022,
  "logo_path": null,
  "name": "21st Century Productions UK",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5023,
  "logo_path": null,
  "name": "Alliance Vivafilm",
  "origin_country": "CA",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Vancouver, British Columbia",
  "homepage": "",
  "id": 5024,
  "logo_path": "/9CkYR0swSEj5iVi9bzx9erLnmzm.png",
  "name": "Mainframe Entertainment",
  "origin_country": "CA",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Santa Clarita, California",
  "homepage": "http://www.bluecactuspictures.com",
  "id": 5027,
  "logo_path": "/7F7LEtukaW0aPRy1xRCkIwP7gMv.png",
  "name": "Blue Cactus Pictures",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5028,
  "logo_path": null,
  "name": "CanWest Global Communications Corporationt",
  "origin_country": "CA",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5031,
  "logo_path": null,
  "name": "Videovision Entertainment",
  "origin_country": "ZA",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5033,
  "logo_path": null,
  "name": "Nonesuch Records",
  "origin_country": "CH",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "https://rainlake.com",
  "id": 5034,
  "logo_path": "/dGaTsnDh2B5JHGdS92j6EzgIc9q.png",
  "name": "Rainlake Productions",
  "origin_country": "US",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5037,
  "logo_path": null,
  "name": "Lagestee Film",
  "origin_country": "NL",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5040,
  "logo_path": null,
  "name": "Morningside Productions",
  "origin_country": null,
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5041,
  "logo_path": null,
  "name": "Anglo-EMI",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "",
  "homepage": "",
  "id": 5043,
  "logo_path": null,
  "name": "Film Art Association",
  "origin_country": "JP",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "London, England",
  "homepage": "http://www.mammothscreen.com/",
  "id": 5100,
  "logo_path": "/utZoiSvzfUPQMK3WmKgLTemHOOQ.png",
  "name": "Mammoth Screen",
  "origin_country": "GB",
  "parent_company": null
},
{
  "description": "",
  "headquarters": "Paris, France",
  "homepage": "https://www.pierrejavauxproductions.com/",
  "id": 7006,
  "logo_path": null,
  "name": "Pierre Javaux Productions",
  "origin_country": "FR",
  "parent_company": null
},
    {
      id: 5542,
      logo_path: "/ayE4LIqoAWotavo7xdvYngwqGML.png",
      name: "Toei Animation",
      origin_country: "JP"
    },
    {
      id: 94584,
      logo_path: "/j42xbuQ7qxluv042zdeiKHZVfAq.png",
      name: "Oasis Animation",
      origin_country: "CA"
    },
    {
      id: 5542,
      logo_path: "/ayE4LIqoAWotavo7xdvYngwqGML.png",
      name: "Toei Animation",
      origin_country: "JP"
    },
    {
      id: 4762,
      logo_path: "/igWZmjr5Zhbnxf7DinSOLoiggLU.png",
      name: "BBC Wales",
      origin_country: "GB"
    },
    {
      id: 78029,
      logo_path: "/qrylL416SnuJZL1SJSzxfvpJfff.png",
      name: "BBC North",
      origin_country: ""
    },
    {
      id: 3164,
      logo_path: "/gyJlH4vQsBuOJXDeaRw57FvCes2.png",
      name: "BBC Worldwide",
      origin_country: "GB"
    },
    {
      id: 7710,
      logo_path: "/iJQIjE9g4FqCDPLzxqoOfQ0e4Xx.png",
      name: "BBC One",
      origin_country: "GB"
    },
    {
      id: 103287,
      logo_path: "/2f1yKuoXx3qdEJVMF46kkXOsVll.png",
      name: "BBC Two",
      origin_country: "GB"
    },
    {
      id: 25677,
      logo_path: "/nwEb65kBNYISxACu9A5ThpWtKbd.png",
      name: "BBC Three",
      origin_country: "GB"
    },
    {
      id: 8090,
      logo_path: "/ktzmUmVCQPjQGblWfDPBLKsIWKA.png",
      name: "BBC Earth",
      origin_country: "GB"
    },
    {
      id: 91536,
      logo_path: "/ah3lNfMwcr1YOV9NZuCFEhwdrLf.png",
      name: "PBS Digital Studios",
      origin_country: "US"
    },
    {
      id: 124017,
      logo_path: null,
      name: "Public Broadcasting Service (PBS)",
      origin_country: ""
    },
    {
      id: 10622,
      logo_path: "/oraLQgdaulLar3nDKUfIYGQyyuj.png",
      name: "Public Broadcasting Service",
      origin_country: "US"
    },
    {
      id: 3268,
      logo_path: "/tuomPhY2UtuPTqqFnKMVHvSb724.png",
      name: "HBO",
      origin_country: "US"
    },
    {
      id: 7429,
      logo_path: "/6in9uMqxXEHx5XgYgkeRBpZ4rPw.png",
      name: "HBO Films",
      origin_country: "US"
    },
    {
      id: 82882,
      logo_path: "/tC3oVZvqpwhAG1uSjpMnmj4nW3O.png",
      name: "HBO Asia",
      origin_country: ""
    },
{
  id: 1205,
  name: "Endgame Entertainment",
  origin_country: "US",
}
],

    }
  },
  methods: {
    infiniteHandler ($state) {
      this.page += 1
      let self = this
      self.counter += 4
        axios
        .get(`/3/company/${this.counter}?api_key=a11ac97c6bdb99adc0845654be0902a8`)
        .then(response => {
          
          if (response.status == 200 && response.status != 34) {
              self.list.push(response.data)
          }
        })                     
        .catch(e => {
          self.errors.push(e)
        })

        axios
        .get(`/3/network/${this.counter + 1 }?api_key=a11ac97c6bdb99adc0845654be0902a8`)
        .then(response => {
          if (response.status == 200 && response.status != 34) {
              self.list.push(response.data)
          }
        })                     
        .catch(e => {
          self.errors.push(e)
        })

        axios
        .get(`/3/network/${this.counter + 2 }?api_key=a11ac97c6bdb99adc0845654be0902a8`)
        .then(response => {
          if (response.status == 200 && response.status != 34) {
              self.list.push(response.data)
          }
        })                     
        .catch(e => {
          self.errors.push(e)
        })

        axios
        .get(`/3/network/${this.counter + 3}?api_key=a11ac97c6bdb99adc0845654be0902a8`)
        .then(response => {
          $state.loaded()
          if (response.status == 200 && response.status != 34) {
              self.list.push(response.data)
          }
        })                     
        .catch(e => {
          $state.loaded()
          self.errors.push(e)
        })
    },    
    selectCountry(opt) {/*
      this.list.filter(item => {
          if(item.code) {
          return item.origin_country== opt.code
          } else return ''
        })
*/
if(opt.name == 'All Countries') {
  this.list1 = this.list
}
else {
  /*
this.list1 = this.list.filter(function (el) {
  return el.origin_country == opt.code
})
*/
this.list1 = []
let self = this
this.list.forEach((item) => {
  if(item.origin_country == opt.code)
  self.list1.push(item)
})

}
// this.list1 = newArray
    },
    toggle (index) {
      // this.accordions.forEach((item) => {
      //   item.active = false
      // })
      this.accordions[index].active = !this.accordions[index].active
    },
  },
  created () {
    this.list1 = this.list
  },
  computed: {
    mobileCheck() {
     var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check
  },
    getFiltered (options) {
        return this.countries.filter(item => {
          if(item.name) {
          return item.name.toLocaleUpperCase().indexOf(this.search.toLocaleUpperCase()) !== -1
          } else return ''
        })
    },        
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/uni-search";
</style>
